import ClickAwayListener from "@mui/base/ClickAwayListener";
import { InputAdornment } from "@mui/material";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersActionBarProps } from "@mui/x-date-pickers/PickersActionBar";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as DatePickerIcon } from "assets/DatePicker.svg";
import { ReactComponent as LeftCalenderIcon } from "assets/LeftCalenderIcon.svg";
import { ReactComponent as RightCalenderIcon } from "assets/RightCalenderIcon.svg";
import moment from "moment";
import React from "react";
import { tokens } from "styles/Tokens";
import Button from "../Button";
import Typography from "../Typography";
import Validation from "../Validation";
import "./Calender.scss";

interface Props {
  name?: string;
  required?: boolean;
  error?: any;
  defaultValue?: any;
  showLable?: boolean;
  buttonView?: boolean;
  sx?: {};
  onChange?: (v: any) => void;
}

const MyActionBar = ({ onAccept, onCancel, onClear, onSetToday }: PickersActionBarProps) => {
  return (
    <DialogActions>
      <Button
        sx={{ width: "100%" }}
        onClick={() => {
          onClear();
        }}
        variant="outlined"
        label={"Clear date"}
      />
    </DialogActions>
  );
};

export default function Calender(props: Props) {
  const { defaultValue = null, required, onChange, name, error, showLable = true, buttonView = false, sx } = props;
  const [date, setDate] = React.useState<any>(defaultValue);
  const [openDatePicker, setOpenDatePicker] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<any>(null);

  const changeDateFormat = (date: any) => {
    const newDate = date ? moment(date).format("YYYY-MM-DD") : date;
    setDate(newDate);
    onChange?.(newDate);
  };

  React.useEffect(() => {
    changeDateFormat(date);
  }, [date]);

  return (
    <>
      <ClickAwayListener onClickAway={(e: any) => setOpenDatePicker(false)}>
        <Box width="100%" textAlign="left">
          {showLable && (
            <>
              <Typography component="span" color={tokens.Text.Feedback.Alert}>
                {required ? " * " : ""}
              </Typography>
              <Typography component="span" variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                Due date
              </Typography>
            </>
          )}
          <Box marginTop="2px" id="calenderInput">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                inputFormat="YYYY-MM-DD"
                className="datePickerWidth"
                value={date}
                open={openDatePicker}
                componentsProps={{
                  actionBar: {
                    actions: ["clear"]
                  }
                }}
                PopperProps={
                  buttonView
                    ? {
                        placement: "auto",
                        anchorEl: anchorEl
                      }
                    : { placement: "auto" }
                }
                onChange={(newValue) => {
                  setOpenDatePicker(false);
                  changeDateFormat(newValue);
                }}
                renderInput={(params) => {
                  params.inputProps = { ...params.inputProps, placeholder: " Select a date" };
                  if (buttonView)
                    return (
                      <Button
                        sx={{ ...sx }}
                        onClick={(event) => {
                          setOpenDatePicker(true);
                          setAnchorEl(event.currentTarget);
                        }}
                        label={date ? moment(date).format("YYYY-MM-DD") : "Add due date"}
                        variant="outlined"
                      />
                    );
                  else
                    return (
                      <TextField
                        onClick={() => setOpenDatePicker(true)}
                        sx={{
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: error ? tokens.Border.Feedback.Alert : "inherit"
                          },
                          "& input::placeholder": {
                            color: tokens.Text.General.Tertiary,
                            opacity: 1
                          }
                        }}
                        {...params}
                      />
                    );
                }}
                components={{
                  OpenPickerIcon: ArrowDown,
                  RightArrowIcon: RightCalenderIcon,
                  LeftArrowIcon: LeftCalenderIcon,
                  ActionBar: MyActionBar
                }}
                showDaysOutsideCurrentMonth
                dayOfWeekFormatter={(day) => day}
                InputAdornmentProps={{
                  onClick: () => setOpenDatePicker((state) => !state)
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" sx={{ marginRight: "11.43px", cursor: "pointer" }}>
                      <DatePickerIcon />
                    </InputAdornment>
                  )
                }}
                disableHighlightToday
              />
            </LocalizationProvider>
          </Box>
          {error && <Validation name={name} type={error?.type} message={error?.message} />}
        </Box>
      </ClickAwayListener>
    </>
  );
}
